import { defineStore } from 'pinia'

export const usePageTransitionStore = defineStore('page transition', {
  state: () => ({
    isTransitioning: false,
    timeline: null
  }),
  actions: {
    startTransition() {
      this.isTransitioning = true
    },
    finishTransition() {
      this.isTransitioning = false
    },
  }
})